import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { FaWhatsapp, FaArrowUp } from "react-icons/fa";

// Layout
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Home from "./pages/Home";
import Products from "./pages/Products";
import Cart from "./pages/Cart";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Wishlist from "./pages/Wishlist";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders";
import NotFound from "./pages/NotFound";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";


// Auth
import Login from "./pages/Login";
import Signup from "./pages/Signup";

// Checkout
import Checkout from "./pages/Checkout";

/* ================= SCROLL TO TOP ON ROUTE ================= */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
};

/* ================= FLOATING BUTTONS ================= */
const FloatingButtons = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* ================= WHATSAPP ================= */}
      <a
        href="https://wa.me/917973891820"
        target="_blank"
        rel="noopener noreferrer"
        className={`fixed right-6 z-[99999]
        w-16 h-16 rounded-full
        bg-[#25D366]
        flex items-center justify-center
        shadow-2xl
        hover:scale-110
        transition-all duration-300
        ${
          showTop
            ? "bottom-24"   // Scroll button ke upar
            : "bottom-6"
        }`}
      >
        <FaWhatsapp size={30} className="text-white" />
      </a>

      {/* ================= SCROLL TO TOP ================= */}
      {showTop && (
        <button
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
          className="fixed right-6 bottom-6
          z-[99999]
          w-14 h-14
          rounded-full
          bg-black
          text-white
          flex items-center justify-center
          shadow-2xl
          hover:bg-[#e7b6a1]
          hover:text-black
          hover:scale-110
          transition-all duration-300"
        >
          <FaArrowUp size={20} />
        </button>
      )}
    </>
  );
};

/* ================= MAIN APP ================= */
function AppLayout() {
  const location = useLocation();

  const hideLayout = ["/login", "/signup"].includes(location.pathname);

  return (
    <>
      {!hideLayout && <Navbar />}

      <main className="min-h-screen bg-[#F6F2EF]">
        <Routes>
          {/* PUBLIC */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* CART */}
          <Route path="/cart" element={<Cart />} />

          {/* AUTH */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* USER */}
          <Route
            path="/wishlist"
            element={
              <ProtectedRoute>
                <Wishlist />
              </ProtectedRoute>
            }
          />

          <Route
            path="/checkout"
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />

          {/* ADMIN */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!hideLayout && (
        <>
          <Footer />
          <FloatingButtons />
        </>
      )}
    </>
  );
}

/* ================= ROOT ================= */
function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppLayout />
    </Router>
  );
}

export default App;